/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
import {
  Button,
  Dialog,
  Paper,
  Grid,
  IconButton,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  DialogTitle,
  DialogActions,
  useMediaQuery,
  FormControlLabel,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Chip,
  Autocomplete,
  Divider,
  Switch,
  Avatar,
  Box,
  Card,
  CardMedia,
  Tooltip,
  DialogContent,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Container } from 'reactstrap';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import ImageIcon from '@mui/icons-material/Image';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import UIContext from '../../context/UIContext';
import axios from '../../utils/axios';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  color: theme.palette.common.white,
  border: 'solid 1px #dee2e6',
  fontWeight: '800',
  backgroundColor: theme.palette.primary.dark,
  padding: '8px 16px',
  whiteSpace: 'nowrap',
}));

const SubCategoryInitialValue = {
  Category_Id: null,
  MainCategory_Id: null,
  Category_Code: '',
  Category_Description: '',
  Active: 'Y',
  Category_Image: '',
  imageFile: null,
};

const filterInitialValue = {
  searchTerm: '',
  Active: true,
};

const ImagePreviewContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  height: '120px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  border: `1px dashed ${theme.palette.divider}`,
}));

const RemoveImageButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: 4,
  right: 4,
  backgroundColor: theme.palette.error.main,
  color: 'white',
  padding: '4px',
  '&:hover': {
    backgroundColor: theme.palette.error.dark,
  },
}));

const PreviewImageButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  bottom: 4,
  right: 4,
  backgroundColor: theme.palette.primary.main,
  color: 'white',
  padding: '4px',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));

const SubCategory = () => {
  const [filterData, setFilterData] = useState(filterInitialValue);
  const [subCategoryTableData, setSubCategoryTableData] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [mainCategories, setMainCategories] = useState([]);
  const [UserId, setUserId] = useState(null);
  const [initialValue, setInitialValue] = useState(SubCategoryInitialValue);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [openDelete, setOpenDelete] = useState(false);
  const [openImageDialog, setOpenImageDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);

  useEffect(() => {
    const UserId = sessionStorage.getItem('UserId');
    setUserId(UserId);
    GetAllSubCategory();
    GetAllMainCategories();
  }, []);

  const GetAllMainCategories = async () => {
    try {
      showLoading();
      const response = await axios.get('Master/MainCategory/GetAllMainCategory');
      setMainCategories(response.data);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  };

  const subCategoryValidationSchema = useMemo(
    () =>
      Yup.object().shape({
        MainCategory_Id: Yup.object().required('Please select Main Category'),
        Category_Code: Yup.string().trim().nullable(),
        Category_Description: Yup.string()
          .trim()
          .min(3, ({ min }) => `Minimum ${min} characters required`)
          .max(100, ({ max }) => `Cannot exceed more than ${max} characters`)
          .required('Enter Category Description')
          .test(
            'unique-combination',
            'This Main Category and Sub Category combination already exists',
            function (value) {
              const { MainCategory_Id } = this.parent;
              if (!MainCategory_Id || !value) return true;

              if (
                edit &&
                initialValue.MainCategory_Id?.MainCategory_Id === MainCategory_Id.MainCategory_Id &&
                initialValue.Category_Description?.toLowerCase() === value?.toLowerCase()
              ) {
                return true;
              }

              return !subCategories.some(
                (item) =>
                  item.MainCategory_Id === MainCategory_Id.MainCategory_Id &&
                  item.Category_Description?.toLowerCase() === value?.toLowerCase() &&
                  item.Category_Id !== initialValue.Category_Id
              );
            }
          ),
        Active: Yup.string().oneOf(['Y', 'N'], 'Please select Yes or No').required('Please select Yes or No'),
        Category_Image: Yup.mixed()
          .test('fileSize', 'Image too large (max 2MB)', (value) => {
            if (!value || typeof value === 'string') return true;
            return value.size <= 2000000;
          })
          .test('fileType', 'Unsupported format (JPEG/PNG only)', (value) => {
            if (!value || typeof value === 'string') return true;
            return ['image/jpeg', 'image/png', 'image/jpg'].includes(value.type);
          }),
      }),
    [subCategories, initialValue, edit]
  );

  async function GetAllSubCategory() {
    try {
      showLoading();
      const response = await axios.get('Master/SubCategory/GetAllSubCategory');
      const dataWithSNo = response.data.map((item, index) => ({
        ...item,
        SNo: index + 1,
      }));
      setSubCategories(dataWithSNo);
      setSubCategoryTableData(dataWithSNo);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  const handleSubmit = async (values) => {
    try {
      showLoading();
      const formData = new FormData();

      Object.entries(values).forEach(([key, value]) => {
        if (key === 'MainCategory_Id') {
          formData.append(key, value?.MainCategory_Id || '');
        } else if (key !== 'imageFile' && key !== 'Category_Image') {
          formData.append(key, value || '');
        }
      });

      if (values.imageFile) {
        formData.append('Category_Image', values.imageFile);
      } else if (values.Category_Image && typeof values.Category_Image === 'string') {
        formData.append('Category_Image', values.Category_Image.split('/').pop());
      }

      if (edit) {
        formData.append('Modify_By', UserId);
        await axios.post('Master/SubCategory/UpdateSubCategory', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        openSnackBar('Sub Category Updated Successfully!', 'success');
      } else {
        formData.append('Created_By', UserId);
        await axios.post('Master/SubCategory/InsertSubCategory', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        openSnackBar('Sub Category Added Successfully!', 'success');
      }

      GetAllSubCategory();
      setOpen(false);
      setEdit(false);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  };

  const DeleteSubCategory = async () => {
    try {
      showLoading();
      await axios.delete(`Master/SubCategory/DeleteSubCategory/${deleteId}`);
      GetAllSubCategory();
      openSnackBar('Sub Category Deleted Successfully!', 'warning');
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    handleCloseDelete();
    setDeleteId(null);
    hideLoading();
  };

  const handleEditClick = (values) => {
    const mainCategory = mainCategories.find((cat) => cat.MainCategory_Id === values.MainCategory_Id);
    setInitialValue({
      ...values,
      MainCategory_Id: mainCategory || null,
      Category_Image: values.Category_Image ? `${axios.defaults.products}/${values.Category_Image}` : null,
    });
  };

  const handleFilterDataChange = (name, value) => {
    setFilterData({ ...filterData, [name]: value });
  };

  useEffect(() => {
    const newTableData = subCategories.filter(
      (subCat) =>
        `${subCat.Category_Description} ${subCat.MainCategory_Description} ${subCat.Category_Code}`
          .toLowerCase()
          .includes(filterData.searchTerm?.toLowerCase()) && subCat.Active === (filterData.Active ? 'Y' : 'N')
    );
    if (page > 0) setPage(0);
    setSubCategoryTableData(newTableData);
  }, [subCategories, filterData]);

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setDeleteId(null);
  };

  const handleCloseDialog = () => {
    setOpen(false);
    setEdit(false);
    setInitialValue(SubCategoryInitialValue);
  };

  const handleImagePreview = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpenImageDialog(true);
  };

  const handleCloseImageDialog = () => {
    setOpenImageDialog(false);
    setSelectedImage(null);
  };

  const { emptyRows, totalRows, currentPage } = useMemo(() => {
    const totalRows = subCategoryTableData.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, totalRows - page * rowsPerPage);

    return { emptyRows, totalRows, currentPage };
  }, [subCategoryTableData, page, rowsPerPage]);

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }}>
        {/* Header Section */}
        <Paper elevation={0} sx={{ p: 3, mb: 3, backgroundColor: 'background.paper', borderRadius: 3 }}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography variant="h4" fontWeight="bold" color="text.primary">
                Sub Category Management
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Manage your product sub categories
              </Typography>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={() => setOpen(true)}
                startIcon={<PlaylistAddIcon />}
                sx={{
                  borderRadius: 2,
                  px: 3,
                  py: 1,
                  textTransform: 'none',
                  fontWeight: 600,
                }}
              >
                Add New Sub Category
              </Button>
            </Grid>
          </Grid>
        </Paper>

        {/* Filter Section */}
        <Paper elevation={0} sx={{ p: 3, mb: 3, backgroundColor: 'background.paper', borderRadius: 3 }}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={8}>
              <TextField
                fullWidth
                variant="outlined"
                color="primary"
                label="Search Sub Categories"
                size="small"
                placeholder="Search by name, main category or code"
                onChange={(e) => handleFilterDataChange('searchTerm', e.target.value)}
                value={filterData.searchTerm}
                InputProps={{
                  sx: { borderRadius: 2 },
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={2}>
                <Typography variant="body1" fontWeight={500}>
                  Show Active Only
                </Typography>
                <Switch
                  size="small"
                  checked={filterData.Active}
                  onChange={(e) => handleFilterDataChange('Active', e.target.checked)}
                  color="primary"
                />
              </Stack>
            </Grid>
          </Grid>
        </Paper>

        {/* Table Section */}
        <TableContainer component={Paper} elevation={0} sx={{ mb: 3, borderRadius: 3 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell align="center">S.No</StyledTableCell>
                <StyledTableCell align="center">Image</StyledTableCell>
                <StyledTableCell align="left">Main Category</StyledTableCell>
                <StyledTableCell align="left">Sub Category</StyledTableCell>
                <StyledTableCell align="center">Category Code</StyledTableCell>
                <StyledTableCell align="center">Status</StyledTableCell>
                <StyledTableCell align="center">Actions</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? subCategoryTableData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : subCategoryTableData
              ).map((subCategory) => (
                <TableRow key={subCategory.Category_Id} hover>
                  <TableCell align="center">{subCategory.SNo}</TableCell>
                  <TableCell align="center">
                    <Box
                      sx={{
                        width: 60,
                        height: 60,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: subCategory.Category_Image ? 'pointer' : 'default',
                      }}
                      onClick={() =>
                        subCategory.Category_Image &&
                        handleImagePreview(`${axios.defaults.products}/${subCategory.Category_Image}`)
                      }
                    >
                      {subCategory.Category_Image ? (
                        <img
                          src={`${axios.defaults.products}/${subCategory.Category_Image}`}
                          alt={subCategory.Category_Description}
                          style={{
                            maxWidth: '100%',
                            maxHeight: '100%',
                            objectFit: 'cover',
                            borderRadius: '4px',
                          }}
                        />
                      ) : (
                        <Avatar sx={{ width: 40, height: 40, bgcolor: 'grey.300' }}>
                          <ImageIcon fontSize="small" color="disabled" />
                        </Avatar>
                      )}
                    </Box>
                  </TableCell>
                  <TableCell align="left">{subCategory.MainCategory_Description}</TableCell>
                  <TableCell align="left">{subCategory.Category_Description}</TableCell>
                  <TableCell align="center">{subCategory.Category_Code || 'N/A'}</TableCell>
                  <TableCell align="center">
                    <Chip
                      label={subCategory.Active === 'Y' ? 'Active' : 'Inactive'}
                      color={subCategory.Active === 'Y' ? 'success' : 'error'}
                      size="small"
                      variant="outlined"
                      icon={
                        subCategory.Active === 'Y' ? (
                          <CheckCircleOutlineIcon fontSize="small" />
                        ) : (
                          <HighlightOffIcon fontSize="small" />
                        )
                      }
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Tooltip title="Edit Sub Category">
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={() => {
                          setEdit(true);
                          setOpen(true);
                          handleEditClick(subCategory);
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete Sub Category">
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => {
                          setDeleteId(subCategory.Category_Id);
                          setOpenDelete(true);
                        }}
                      >
                        <DeleteForeverIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
              {emptyRows > 0 && (
                <TableRow style={{ height: 73 * emptyRows }}>
                  <TableCell colSpan={7} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <Box display="flex" justifyContent="center" mt={3}>
          <TablePagination
            rowsPerPageOptions={[10, 25, 50, { label: 'All', value: -1 }]}
            component="div"
            count={totalRows}
            rowsPerPage={rowsPerPage}
            page={currentPage}
            onPageChange={(event, newPage) => setPage(newPage)}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }}
            sx={{
              '& .MuiTablePagination-toolbar': {
                padding: 1,
              },
              '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                marginBottom: 0,
              },
            }}
          />
        </Box>

        {/* Add/Edit Dialog - COMPACT DESIGN */}
        <Dialog maxWidth="md" open={open} onClose={handleCloseDialog} fullWidth>
          <DialogTitle sx={{ pb: 1 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h5" fontWeight="bold">
                {edit ? 'Edit' : 'Add'} Sub Category
              </Typography>
              <IconButton onClick={handleCloseDialog} size="large">
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent sx={{ pt: 1 }}>
            <Formik
              validationSchema={subCategoryValidationSchema}
              initialValues={initialValue}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ submitForm, values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
                <Form>
                  <Grid container spacing={2} mt={1}>
                  

                    {/* Right side - Form Inputs (80%) */}
                    <Grid item xs={12} sm={9}>
                      <Grid container spacing={2} >
                        <Grid item xs={8}>
                          <Autocomplete
                            options={mainCategories}
                            size="small"
                            getOptionLabel={(option) => option.MainCategory_Description}
                            isOptionEqualToValue={(option, value) => option.MainCategory_Id === value?.MainCategory_Id}
                            value={values.MainCategory_Id}
                            onChange={(event, newValue) => {
                              setFieldValue('MainCategory_Id', newValue);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Main Category"
                                required
                                fullWidth
                                error={touched.MainCategory_Id && !!errors.MainCategory_Id}
                                helperText={touched.MainCategory_Id && errors.MainCategory_Id}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Category Code (Optional)"
                            name="Category_Code"
                            onBlur={handleBlur}
                            error={touched.Category_Code && !!errors.Category_Code}
                            helperText={touched.Category_Code && errors.Category_Code}
                            value={values.Category_Code}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Sub Category Description"
                            name="Category_Description"
                            required
                            onBlur={handleBlur}
                            error={touched.Category_Description && !!errors.Category_Description}
                            helperText={touched.Category_Description && errors.Category_Description}
                            value={values.Category_Description}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <FormControl component="fieldset" fullWidth>
                            <FormLabel component="legend">Active Status</FormLabel>
                            <RadioGroup row value={values.Active} name="Active" onChange={handleChange}>
                              <FormControlLabel value="Y" control={<Radio color="primary" />} label="Yes" />
                              <FormControlLabel value="N" control={<Radio color="error" />} label="No" />
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                          <Divider sx={{ my: 1 }} />
                          <Box display="flex" justifyContent="flex-end" gap={1}>
                            <Button
                              variant="outlined"
                              color="secondary"
                              onClick={handleCloseDialog}
                              disabled={isSubmitting}
                              sx={{
                                borderRadius: 1,
                                px: 2,
                                py: 0.5,
                                minWidth: 80,
                                textTransform: 'none',
                                fontWeight: 600,
                              }}
                            >
                              Cancel
                            </Button>
                            <Button
                              variant="contained"
                              color={edit ? 'warning' : 'primary'}
                              onClick={submitForm}
                              disabled={isSubmitting}
                              sx={{
                                borderRadius: 1,
                                px: 2,
                                py: 0.5,
                                minWidth: 100,
                                textTransform: 'none',
                                fontWeight: 600,
                              }}
                            >
                              {edit ? 'Update' : 'Save'}
                            </Button>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                      {/* Left side - Image Preview (20%) */}
                    <Grid item xs={12} sm={3}>
                      <input
                        accept="image/*"
                        style={{ display: 'none' }}
                        id="subcategory-image-upload"
                        type="file"
                        onChange={(event) => {
                          const file = event.target.files[0];
                          if (file) {
                            setFieldValue('imageFile', file);
                            setFieldValue('Category_Image', URL.createObjectURL(file));
                          }
                        }}
                      />
                      <label htmlFor="subcategory-image-upload">
                        <Button
                          variant="outlined"
                          component="span"
                          fullWidth
                          startIcon={<AddPhotoAlternateIcon />}
                          sx={{ mb: 1 }}
                        >
                          Upload Image
                        </Button>
                      </label>

                      <ImagePreviewContainer>
                        {values.Category_Image ? (
                          <>
                            <img
                              src={values.Category_Image}
                              alt="Category Preview"
                              style={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'contain',
                              }}
                            />
                            <RemoveImageButton
                              size="small"
                              onClick={() => {
                                setFieldValue('Category_Image', '');
                                setFieldValue('imageFile', null);
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </RemoveImageButton>
                            <PreviewImageButton size="small" onClick={() => handleImagePreview(values.Category_Image)}>
                              <VisibilityIcon fontSize="small" />
                            </PreviewImageButton>
                          </>
                        ) : (
                          <Box textAlign="center">
                            <ImageIcon fontSize="large" color="disabled" />
                            <Typography variant="caption" display="block" color="text.secondary">
                              No image selected
                            </Typography>
                          </Box>
                        )}
                      </ImagePreviewContainer>
                      {touched.Category_Image && errors.Category_Image && (
                        <Typography variant="caption" color="error">
                          {errors.Category_Image}
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </DialogContent>
        </Dialog>

        {/* Delete Confirmation Dialog */}
        <Dialog open={openDelete} onClose={handleCloseDelete} maxWidth="xs" fullWidth>
          <Paper elevation={0} sx={{ p: 3, borderRadius: 3 }}>
            <DialogTitle>
              <Typography variant="h5" fontWeight="bold">
                Confirm Delete
              </Typography>
            </DialogTitle>
            <Box p={2}>
              <Typography>Are you sure you want to delete this sub category? This action cannot be undone.</Typography>
            </Box>
            <DialogActions sx={{ p: 2 }}>
              <Button
                variant="outlined"
                onClick={handleCloseDelete}
                sx={{
                  borderRadius: 2,
                  px: 3,
                  py: 1,
                  minWidth: 100,
                  textTransform: 'none',
                  fontWeight: 600,
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={DeleteSubCategory}
                autoFocus
                sx={{
                  borderRadius: 2,
                  px: 3,
                  py: 1,
                  minWidth: 100,
                  textTransform: 'none',
                  fontWeight: 600,
                }}
              >
                Delete
              </Button>
            </DialogActions>
          </Paper>
        </Dialog>

        {/* Image Preview Dialog */}
        <Dialog open={openImageDialog} onClose={handleCloseImageDialog} maxWidth="md" fullWidth>
          <Paper elevation={0} sx={{ p: 3, borderRadius: 3 }}>
            <DialogTitle>
              <Typography variant="h5" fontWeight="bold">
                Sub Category Image Preview
              </Typography>
            </DialogTitle>
            <Box p={2} display="flex" justifyContent="center">
              <Card sx={{ maxWidth: '100%', borderRadius: 2 }}>
                <CardMedia
                  component="img"
                  image={selectedImage}
                  alt="Sub Category Image"
                  sx={{ maxHeight: '70vh', objectFit: 'contain' }}
                />
              </Card>
            </Box>
            <DialogActions>
              <Button
                onClick={handleCloseImageDialog}
                color="primary"
                sx={{
                  borderRadius: 2,
                  px: 3,
                  py: 1,
                  minWidth: 100,
                  textTransform: 'none',
                  fontWeight: 600,
                }}
              >
                Close
              </Button>
            </DialogActions>
          </Paper>
        </Dialog>
      </Container>
    </>
  );
};

export default SubCategory;
